var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsdtTrx = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_802)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_623_802)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85921 3.13258L0.0244914 15.02C0.0022886 15.0642 -0.00474733 15.1142 0.00441255 15.1625C0.0135724 15.2109 0.0384476 15.2552 0.0754003 15.2888L15.8336 29.9351C15.8783 29.9767 15.938 29.9999 16 29.9999C16.062 29.9999 16.1216 29.9767 16.1664 29.9351L31.9246 15.2898C31.9615 15.2561 31.9864 15.2118 31.9956 15.1634C32.0047 15.1151 31.9977 15.0651 31.9755 15.0209L26.1407 3.13349C26.1219 3.09357 26.0916 3.05975 26.0535 3.03607C26.0154 3.0124 25.9711 2.99987 25.9258 2.99999H6.07605C6.03057 2.99944 5.9859 3.01166 5.94742 3.03519C5.90895 3.05872 5.87831 3.09254 5.85921 3.13258Z",
    fill: "#009393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0246 16.2408C17.9114 16.249 17.3269 16.2828 16.0231 16.2828C14.9861 16.2828 14.2498 16.2527 13.9915 16.2408C9.9838 16.0698 6.99243 15.3931 6.99243 14.5829C6.99243 13.7728 9.9838 13.097 13.9915 12.9233V15.5668C14.2535 15.5851 15.004 15.6281 16.041 15.6281C17.2855 15.6281 17.9086 15.5778 18.0208 15.5678V12.9251C22.02 13.0979 25.0048 13.7746 25.0048 14.5829C25.0048 15.3913 22.0209 16.0679 18.0208 16.2399L18.0246 16.2408ZM18.0246 12.6517V10.2861H23.6057V6.67871H8.41034V10.2861H13.9905V12.6508C9.45492 12.8529 6.04402 13.7243 6.04402 14.7686C6.04402 15.8128 9.45492 16.6834 13.9905 16.8864V24.4669H18.0236V16.8836C22.5489 16.6815 25.9541 15.811 25.9541 14.7676C25.9541 13.7243 22.5517 12.8538 18.0236 12.6508L18.0246 12.6517Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 32C28.4183 32 32 28.4183 32 24C32 19.5817 28.4183 16 24 16C19.5817 16 16 19.5817 16 24C16 28.4183 19.5817 32 24 32Z",
    fill: "#FF060A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8912 22.7113C27.4966 22.3218 26.9508 21.727 26.5063 21.3051L26.48 21.2854C26.4362 21.2478 26.3869 21.2184 26.334 21.1982C25.2621 20.9845 20.2736 19.9875 20.1762 20.0001C20.149 20.0042 20.1229 20.0148 20.1 20.0311L20.075 20.0521C20.0442 20.0856 20.0208 20.1259 20.0066 20.1703L20 20.1886V20.2884V20.3039C20.5616 21.9759 22.779 27.4531 23.2157 28.7384C23.242 28.8256 23.2919 28.9916 23.3853 29H23.4064C23.4563 29 23.6694 28.6991 23.6694 28.6991C23.6694 28.6991 27.4782 23.7604 27.8636 23.2345C27.9135 23.1697 27.9575 23.1 27.9951 23.0263C28.0047 22.9687 28.0002 22.9094 27.982 22.8542C27.9637 22.799 27.9325 22.7498 27.8912 22.7113ZM24.6466 23.2865L26.2722 21.8451L27.2257 22.7845L24.6466 23.2865ZM24.0153 23.1923L21.2166 20.7398L25.7448 21.6328L24.0153 23.1923ZM24.2678 23.8349L27.1323 23.3413L23.8575 27.56L24.2678 23.8349ZM20.8365 20.9845L23.7812 23.6563L23.3551 27.5628L20.8365 20.9845Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_623_802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 27,
    fill: "white",
    transform: "translate(0 3)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsdtTrx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/USDT_TRX.4de308c09f7c72c2ba5c6826e7c65025.svg";